import { useEffect } from 'react';
import { useHealthReadinessQuery } from '@/lib/api/health-readiness';
import { itemKey, resolveItem } from './model';
import { targetOfItem, useHrNavigate } from './navigation';

/**
 * An old link's `domain-name:<name>` hint (the Budget and Schedule tabs,
 * the milestone notification), resolved against the composite read: the
 * domain with that name opens on the Domains tab, else the first domain
 * (T-0224's rule). Replaces the URL, so Back skips the hint.
 */
export function ResolveHint({ engagementId, hint }: { engagementId: string; hint: string }) {
  const { data: view } = useHealthReadinessQuery(engagementId);
  const go = useHrNavigate(engagementId);
  const resolved = view ? itemKey(resolveItem(view, hint)) : null;
  useEffect(() => {
    if (resolved) go(targetOfItem(resolved), { replace: true });
  }, [resolved, go]);
  return null;
}
